<template>
    <div>
        <div class="login-header fp-login-header">
        </div>
        <div class="paper form">
            <div class="paper form login-card">
                <div>
                  <a :href="this.view.routes.rota_office_index">
                    <img class="img-responsive center-block" :src="this.view.wl_logo">
                  </a>
                </div>
                <h3>{{view.translations.label_enter_new_password_v5}}</h3>
                <h5>{{view.translations.label_choose_secure_password_v5}}</h5>
                <form
                    id="formRegister"
                    ref="formRegister"
                    :action="view.routes.rota_office_change_password"
                    method="post"
                    class="form-change-password"
                    @submit="changePasswordSubmit"
                >
                    <div :class="['text-left', input_password == '' ? '' : ($v.input_password.$invalid ? 'has-error' : 'has-success') ]">
                        <label for="password" class="form-label">{{view.translations.change_password_label_new_password}} *</label>
                        <input
                            type="password"
                            name="password"
                            pattern="^(?=.*\d)(?=.*[a-z]).{6,20}$"
                            required
                            :title="view.translations.label_password_must_be_x_to_y_characters_long_v5"
                            v-model="input_password"
                            @change="onChange('input_password_v', input_password)"
                        />
                    </div>
                    <div :class="['text-left', input_confirm_password == '' ? '' : ($v.input_confirm_password.$invalid ? 'has-error' : 'has-success') ]">
                        <label for="confirm_password" class="form-label">{{view.translations.label_repeat_password_v5}} *</label>
                        <input
                            type="password"
                            name="confirm_password"
                            required
                            v-model="input_confirm_password"
                            @change="onChange('input_confirm_password_v', input_confirm_password)"
                        >
                    </div>
                    <div class="checkbox">
                        <input
                            type="checkbox"
                            name="logout_all_devices"
                            id="logout_all_devices"
                            v-show="false"
                            v-model="checkbox_logout_all_devices"
                        >
                        <label for="logout_all_devices">{{view.translations.change_password_logout_all_devices}}</label>
                    </div>
                    <div>
                        <button
                            class="btn-success display-block"
                            type="submit"
                            :disabled="$v.input_password.$invalid || $v.input_confirm_password.$invalid"
                        >
                            {{view.translations.label_change_password_v5}}
                        </button>
                    </div>
                    <div class="separator">
                        <hr/><span>
                            {{view.translations.label_or_v5}}
                        </span><hr/>
                    </div>
                </form>
                <div class="cp-row-links">
                    <div class="dont-have-account">
                        <span>{{view.translations.label_dont_have_an_v5.trim()}}&nbsp;</span><a :href="view.routes['dont-have-account']" @click="dontHaveAccount" >{{view.translations.label_account_v5}}</a>
                    </div>
                    <div class="separator"></div>
                    <div class="go-back-login">
                        <span>{{view.translations.label_back_to_v5.trim()}}&nbsp;</span><a :href="view.routes.rota_office_login" @click="goBackToLogin" >{{view.translations.label_login_v5}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const { required, minLength, maxLength, sameAs,  helpers } = require('vuelidate/lib/validators')
    const letterAndNumber = helpers.regex('letterAndNumber', /^(?=.*\d)(?=.*[a-z]).{6,20}$/);

    export default {
        name: 'lv5-cp-form',
        props: ['view'],
        validations: {
            input_password: {
                required,
                minLength: minLength(6),
                maxLength: maxLength(20),
                letterAndNumber: letterAndNumber
            },
            input_password_v: { // just for lazy validation
                required,
                minLength: minLength(6),
                maxLength: maxLength(20),
                letterAndNumber: letterAndNumber
            },
            input_confirm_password: {
                required,
                sameAsPassword: sameAs('input_password')
            },
            input_confirm_password_v: {
                required,
                sameAsPassword: sameAs('input_password_v')
            }
        },
        data: function() {
            return {
                checkbox_logout_all_devices: true,
                input_password: '',
                input_password_v: '', // just for lazy validation
                input_confirm_password: '',
                input_confirm_password_v: '' // just for lazy validation
            }
        },
        methods: {
            changePasswordSubmit(){
                this.$emit('change-password-submit');
            },
            dontHaveAccount(){
                this.$emit('dont-have-account', 'change-password');
            },
            goBackToLogin(){
                this.$emit('go-back-to-login', 'change-password');
            },
            onChange(key, value) {
                this[key] = value;
                this.$v[key].$touch();
            }
        },
        watch: {
            '$v.$invalid': {
                handler: function(newVal, oldVal) {
                    if( !newVal ) {
                        this.$toast.clear();
                    }
                },
                deep: true
            },
            '$v.input_password_v.required': {
                handler: function(newVal, oldVal) {
                    if( !newVal ) {
                        this.$toast.error( window.getInnerComponent(`${this.view.translations.change_password_label_new_password} ${this.view.translations.label_required_v5}`) );
                    }
                },
                deep: true
            },
            '$v.input_password_v.minLength': {
                handler: function(newVal, oldVal) {
                    if( !newVal ) {
                         this.$toast.error( window.getInnerComponent(this.view.translations.label_password_must_be_at_least_x_characters_long_v5) );
                    }
                },
                deep: true
            },
            '$v.input_password_v.maxLength': {
                handler: function(newVal, oldVal) {
                    if( !newVal ) {
                        this.$toast.error( window.getInnerComponent(this.view.translations.label_password_must_have_a_maximum_of_x_characters_v5) );
                    }
                },
                deep: true
            },
            '$v.input_password_v.letterAndNumber': {
                handler: function(newVal, oldVal) {
                    if( !newVal ) {
                        this.$toast.error( window.getInnerComponent(this.view.translations.label_password_must_contain_letters_and_numbers_v5) );
                    }
                },
                deep: true
            },

            '$v.input_confirm_password_v.required': {
                handler: function(newVal, oldVal) {
                    if( !newVal ) {
                        this.$toast.error( window.getInnerComponent(`${this.view.translations.label_repeat_password_v5} ${this.view.translations.label_required_v5}`) );
                    }
                },
                deep: true
            },
            '$v.input_confirm_password_v.sameAsPassword': {
                handler: function(newVal, oldVal) {
                    if( !newVal && this.input_confirm_password_v !== undefined && this.input_confirm_password_v !== null && this.input_confirm_password_v !== '') {
                        this.$toast.error( window.getInnerComponent(this.view.translations.label_different_passwords_v5) );
                    }
                },
                deep: true
            },
        },
        mounted(){
            let vm = this;
            $(window).on('load', function(){
                if(vm.view.data.back_toastr_message !== false){
                    vm.$toast[vm.view.data.back_toastr_message_type]( window.getInnerComponent(vm.view.data.back_toastr_message) )
                }
            })
        }
    }
</script>
<style >
.btn-success:focus{
  box-shadow: 0 0.48rem 1.52rem -0.32rem #0a79e9 !important;
}

</style>
<style scoped lang="scss">

  *{
    font-family: "Manrope" !important;
  }
  .login-card {
    background: #F9FBFB !important;
  }
  .form-change-password{
    margin-left: 3.18rem !important;
    margin-right: 3.18rem !important;
  }
  .builderall-css .login-card h3 {
    color: #0053C2 !important;
    font-weight: 700 !important;
    font-size: 1.97rem !important;
    letter-spacing: 0.016rem !important;
    font-weight: 800 !important;
  }
  .builderall-css .login-card h5{
    font-size: 1.2rem !important;
    margin-top: 0.62rem !important;
    margin-bottom: 0.9rem !important;
    color: #ACACAC !important;
  }
  .form-label{
      color:#097EF6 !important;
      //font-size: 0.87rem !important;
  }
  .btn-success{
    background-color: #097EF6 !important;
    font-size: 1.5rem !important;
    font-family: "Roboto" !important;
    border-style: hidden !important;
    outline: none !important;
  }
  .btn-success:hover, .btn-success:focus{
  background-color: #097EF6 !important;
  box-shadow: 0 0.48rem 1.52rem -0.32rem #0a79e9 !important;
  }

  .img-responsive.center-block {
    width: 18rem !important;
    margin-top: 6.25rem !important;
    margin-bottom: 2rem !important;
  }
  .builderall-css .login-card .fp-row-links .go-back-login, .builderall-css .login-card .cp-row-links .go-back-login{
    font-size: 1.2rem !important;
    margin-bottom: 6.25rem !important;
    margin-right: 3.18rem !important;
    color: #ACACAC !important;
  }

  .builderall-css .login-card .fp-row-links .dont-have-account, .builderall-css .login-card .fp-row-links .go-back-login, .builderall-css .login-card .cp-row-links .dont-have-account, .builderall-css .login-card .cp-row-links .go-back-login {
    font-size: 1.2rem !important;
    margin-bottom: 6.25rem !important;
    margin-left: 3.18rem !important;
    color: #ACACAC !important;
  }
  .separator{
    font-size: 1.2rem !important;
  }
  .checkbox label{
    font-size: 1.2rem !important;
    color: #ACACAC !important;
  }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/wl-auth/forms/changePassword.vue